import AttachmentDoc from '@/assets/icons/attachements/AttachmentDoc';
import AttachmentDefault from '@/assets/icons/attachements/AttachmentDefault';
import AttachmentDocx from '@/assets/icons/attachements/AttachmentDocx';
import AttachmentJpg from '@/assets/icons/attachements/AttachmentJpg';
import AttachmentOdt from '@/assets/icons/attachements/AttachmentOdt';
import AttachmentPdf from '@/assets/icons/attachements/AttachmentPdf';
import AttachmentPng from '@/assets/icons/attachements/AttachmentPng';

/**
 * The 44x44 file tile, by content type.
 *
 * Each asset draws its own coloured square — PDF is #E4626F, and the rest carry
 * their own — so the tile is the icon rather than a wrapper around one. That is
 * what the design's per-type `File` variants render as (Figma 20116:75433).
 *
 * Extracted from `AttachmentPreview`, which held the only copy of this mapping;
 * the internal email composer needs the same one, and two lists would drift.
 */
const ICON_BY_CONTENT_TYPE: Record<string, typeof AttachmentDefault> = {
  'application/pdf': AttachmentPdf,
  'application/msword': AttachmentDoc,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    AttachmentDocx,
  'application/vnd.oasis.opendocument.text': AttachmentOdt,
  'image/jpeg': AttachmentJpg,
  'image/jpg': AttachmentJpg,
  'image/png': AttachmentPng,
};

/** Falls back to the generic tile — an unknown type still gets a card. */
export const fileTypeIcon = (contentType?: string | null) =>
  ICON_BY_CONTENT_TYPE[contentType ?? ''] ?? AttachmentDefault;
